import { formatRouteForAAB } from './format-route-for-aab.js';

const urlFromSessionStorageItem = ({ sessionStorageItem , appointmentMenuItems , appointmentRoute  })=>{
    try {
        const state = JSON.parse(sessionStorageItem);
        if (!Object.keys(state === null || state === void 0 ? void 0 : state.queryParams).length) {
            return appointmentMenuItems;
        }
        return formatRouteForAAB({
            appointmentMenuItems,
            appointmentRoute,
            route: state === null || state === void 0 ? void 0 : state.currentRoute,
            searchParams: new URLSearchParams(state === null || state === void 0 ? void 0 : state.queryParams).toString()
        });
    } catch (e) {
        return appointmentMenuItems;
    }
};

export { urlFromSessionStorageItem };
//# sourceMappingURL=url-from-session-storage-item.js.map
